module.exports = __webpack_public_path__ + "img/page-04.2ed13fde.jpg";